import { render, staticRenderFns } from "./XiongMaoView.vue?vue&type=template&id=6edc524e"
import script from "./XiongMaoView.vue?vue&type=script&lang=js"
export * from "./XiongMaoView.vue?vue&type=script&lang=js"
import style0 from "./XiongMaoView.vue?vue&type=style&index=0&id=6edc524e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports